import {Component} from '@angular/core';
import {SpriteImageBaseComponent} from '~shared/ng/components/sprite-image/sprite-image.component';
import {NgClass, NgStyle} from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-sprite-image',
    templateUrl: '../../../../../../shared/ng/components/sprite-image/sprite-image.component.html',
    styleUrl: '../../../../../../shared/ng/components/sprite-image/sprite-image.component.scss',
    providers: [],
    imports: [
        NgStyle,
        NgClass
    ]
})
export class SpriteIconComponent extends SpriteImageBaseComponent {

    public imageUrl = '../../../../assets/icons/sprite-icons.svg';

    constructor() {
        super();
    }
}
